export default __webpack_public_path__ + "static/media/image6.61141b3f.jpg";